const features = [
  {
    icon: 'ri-home-heart-line',
    title: '完全個室制',
    description: '他のお客様と空間を共有しない完全プライベートな個室。周りを気にせず、自分だけの時間をお過ごしいただけます。',
    img: 'https://public.readdy.ai/ai/img_res/4a0d098f9847d16d3ebc8594aa4e3822.jpg',
  },
  {
    icon: 'ri-leaf-line',
    title: '厳選オーガニック素材',
    description: '身体に安心して使える天然・オーガニック成分の製品のみを厳選。肌へのやさしさと高い効果を両立しています。',
    img: 'https://readdy.ai/api/search-image?query=organic%20natural%20skincare%20products%20spa%20arrangement%2C%20botanical%20herbs%2C%20essential%20oils%2C%20green%20plants%2C%20white%20stone%20background%2C%20minimalist%20flat%20lay%2C%20clean%20natural%20wellness%20products%2C%20sage%20green%20and%20cream%20colors&width=700&height=500&seq=feat002&orientation=landscape',
  },
  {
    icon: 'ri-user-heart-line',
    title: '改善型アプローチ',
    description: '単なる「ほぐし」にとどまらず、お悩みの根本原因にアプローチする改善型の施術スタイルで、長期的な変化をサポートします。',
    img: 'https://readdy.ai/api/search-image?query=skilled%20therapist%20hands%20performing%20precise%20gentle%20massage%20technique%2C%20professional%20spa%20treatment%2C%20warm%20lighting%2C%20natural%20oil%2C%20therapeutic%20skilled%20bodywork%2C%20holistic%20wellness%2C%20cozy%20spa%20environment&width=700&height=500&seq=feat003&orientation=landscape',
  },
];

export default function Features() {
  return (
    <section className="py-28 px-8 bg-[#f4f1ec]">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-[#6b7c5c] text-xs tracking-[0.35em] mb-3"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Why Choose Us
          </p>
          <h2
            className="text-stone-800 text-4xl md:text-5xl font-light"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Moonseedが選ばれる理由
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div key={feat.title} className="group relative rounded-2xl overflow-hidden cursor-pointer" style={{ height: '380px' }}>
              <img
                src={feat.img}
                alt={feat.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/10" />
              <div className="absolute inset-0 p-7 flex flex-col justify-end">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm mb-4">
                  <i className={`${feat.icon} text-white text-xl`} />
                </div>
                <h3
                  className="text-white text-xl font-light mb-3"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {feat.title}
                </h3>
                <p
                  className="text-white/75 text-xs leading-relaxed opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {feat.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
